<template>
  <section>
    <div class="bg-lifeboost-red-lighter">
      <div
          class="relative w-full px-5 py-12 mx-auto overflow-hidden max-w-screen-2xl lg:px-14 xl:px-20 2xl:px-12 xl:py-14 2xl:py-20">
        <div class="flex flex-wrap items-center">
          <div class="w-full md:w-1/2 xl:w-5/12 md:pr-10 xl:pr-28 space-y-3.5 lg:space-y-5 pb-7 md:pb-0 text-center">
            <h2 class="text-3xl font-extrabold md:text-3xl xl:text-5xl font-ww-medium" v-html="headTitle"></h2>
            <p class="text-xl font-medium leading-tight text-gray-900" v-html="headSubtitle"></p>
          </div>
          <div class="w-full md:w-1/2 md:ml-auto md:pl-10">
            <ul class="max-w-xl" v-for="(item, index) in listItem">
              <li class="flex overflow-hidden">
                <div class="relative pb-8 afterbotomBorder">
                  <div
                      class="relative z-10 flex items-center justify-center w-16 h-16 p-3 border border-black rounded-full lg:w-20 lg:h-20 lg:p-5 bg-lifeboost-red-lighter">

                    <nuxt-img
                        class="w-full h-full rounded-lg lg:mb-0"
                        width="38"
                        height="38"
                        loading="lazy"
                        format="webp"
                        :alt="item.imageAlt"
                        :src="item.image"
                    ></nuxt-img>

                  </div>
                  <svg class="absolute hidden transform -translate-x-1/2 bottom-1 left-1/2"
                       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14.5px"
                       height="10.5px">
                    <path fill-rule="evenodd" stroke="rgb(0, 0, 0)" stroke-width="1px" stroke-linecap="butt"
                          stroke-linejoin="miter" fill-opacity="0" fill="rgb(0, 0, 0)"
                          d="M1.378,0.499 L7.000,7.640 L12.622,0.499 "></path>
                  </svg>
                </div>
                <div class="pl-6 pt-2.5 pb-8 text-xl font-medium leading-tight text-gray-900 space-y-2.5" v-html="item.text">

                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>


defineProps({

  headTitle: {
    type: String,
    default: 'Why Choose Lifeboost Flavored Coffee Over Conventional Flavored Coffee?',
  },
  headSubtitle: {
    type: String,
    default: 'Most conventional flavored coffees use low quality bean blends since the coffee is being flavored, and then they spray it with propylene glycol so that flavor sticks to the beans. Then they use artificial flavors to flavor the coffee. At Lifeboost, we do not cut corners and focus on the highest quality we can find.',
  },

  listItem: {
    type: Array,
    default: () => [
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-1.png',
        },
        imageAlt: {
          type: String,
          default: 'image SINGLE ORIGIN'
        },
        text: {
          type: String,
          default: 'SINGLE ORIGIN: We use the same exact beans as our main roasts!'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-2.png',
        },
        imageAlt: {
          type: String,
          default: 'PROPYLENE GLYCOL FREE'
        },
        text: {
          type: String,
          default: 'PROPYLENE GLYCOL FREE: We use ethanol (alcohol) to coat the beans which evaporates leaving the flavor.'
        },
      },
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-3.png',
        },
        imageAlt: {
          type: String,
          default: 'SAME ROASTING PROCESS'
        },
        text: {
          type: String,
          default: 'SAME ROASTING PROCESS: We use the same beans and same roasting process to ensure our flavored coffees are stomach friendly!'
        },
      },
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-4.png',
        },
        imageAlt: {
          type: String,
          default: 'image delicious flavor'
        },
        text: {
          type: String,
          default: 'PLANT DERIVED NATURAL FLAVORS: Our natural flavorings for coffee are made with plant-derived ingredients, while our organic flavoring oils for coffee are made with certified organic ingredients.'
        },
      },
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-5.png',
        },
        imageAlt: {
          type: String,
          default: '3RD PARTY TESTED FOR OVER 450 TOXINS'
        },
        text: {
          type: String,
          default: '3RD PARTY TESTED FOR OVER 450 TOXINS: We\'re drinking these daily, so we want to make sure it\'s as clean as possible!'
        },
      },
      {
        image: {
          type: String,
          default: 'assets/images/tc-icon-6.png',
        },
        imageAlt: {
          type: String,
          default: 'ZERO SUGAR and ZERO FAT'
        },
        text: {
          type: String,
          default: 'ZERO SUGAR and ZERO FAT: Skip all the extra calories and "still have your cake and eat it too" well, drink it at least  ;-)'
        }
      },
      // Add more default items here...
    ],
  },


})

defineBuilderComponent({
    friendlyName: "WhyChooseLifeboost",
    canHaveChildren: true,
    inputs: [
        {
            name: "headTitle",
            type: "richText",
            defaultValue: "Why Choose Lifeboost Flavored Coffee Over Conventional Flavored Coffee?"
        },
        {
            name: "headSubtitle",
            type: "richText",
            defaultValue: "Most conventional flavored coffees use low quality bean blends since the coffee is being flavored, and then they spray it with propylene glycol so that flavor sticks to the beans. Then they use artificial flavors to flavor the coffee. At Lifeboost, we do not cut corners and focus on the highest quality we can find."
        },
        {
            name: "listItem",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ]
                },
                {
                    name: "imageAlt",
                    type: "text"
                },
                {
                    name: "text",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    image: "assets/images/tc-icon-1.png",
                    imageAlt: "image SINGLE ORIGIN",
                    text: "SINGLE ORIGIN: Signature, low acid, specialty bean roasts! (No blending beans here)"
                },
                {
                    image: "assets/images/tc-icon-2.png",
                    imageAlt: "PROPYLENE GLYCOL FREE",
                    text: "PROPYLENE GLYCOL FREE: We use ethanol (alcohol) to coat the beans which evaporates leaving the flavor."
                },
                {
                    image: "assets/images/tc-icon-3.png",
                    imageAlt: "SAME ROASTING PROCESS",
                    text: "SAME ROASTING PROCESS: We use the same beans and same roasting process to ensure our flavored coffees are stomach friendly!"
                },
                {
                    image: "assets/images/tc-icon-4.png",
                    imageAlt: "image delicious flavor",
                    text: "PLANT DERIVED NATURAL FLAVORS: Our natural flavorings for coffee are made with plant-derived ingredients, while our organic flavoring oils for coffee are made with certified organic ingredients."
                },
                {
                    image: "assets/images/tc-icon-5.png",
                    imageAlt: "3RD PARTY TESTED FOR OVER 450 TOXINS",
                    text: "3RD PARTY TESTED FOR OVER 450 TOXINS: We're drinking these daily, so we want to make sure it's as clean as possible!"
                },
                {
                    image: "assets/images/tc-icon-6.png",
                    imageAlt: "ZERO SUGAR and ZERO FAT",
                    text: "ZERO SUGAR and ZERO FAT: Skip all the extra calories and \"still have your cake and eat it too\" well, drink it at least  ;-)"
                }
            ]
        }
    ]
});
</script>